import { Component, ElementRef, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';

import { FileUpload, FileUploadConfig, Translation } from 'src/app/pages/driver-import/driver-import-interfaces';

import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'vrm-file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.scss'],
})
export class FileUploaderComponent implements OnDestroy {
  @Output() selectionError: EventEmitter<any> = new EventEmitter();
  @Input() config: FileUploadConfig;
  translation: Translation;
  selectedFile: FileUpload = {
    file: null,
    isUploadInProgress: false,
    uploadResult: null,
  };

  @ViewChild('fileSelector', { static: false }) fileSelector!: ElementRef;

  fileSelectionForm: FormGroup;
  fileSelected: boolean = false;

  private destroy$ = new Subject<void>();

  constructor(public cService: CommonService, private translate: TranslateService) {
    this.fileSelectionForm = new FormGroup({
      file_selection: new FormControl(),
    });
    this.translate.get(['DRIVER_IMPORT']).subscribe({
      next: (translation) => {
        this.translation = translation.DRIVER_IMPORT;
      },
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  handleFileInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0] || null;
    this.selectFile(file);
  }

  openFileSelector(): void {
    const file_selection = this.fileSelector.nativeElement;
    file_selection.click();
  }

  selectFile(file: File | null): void {
    if (!file) {
      console.error('No file selected.');
      return;
    }

    const fileType = file.type.split(';')[0].trim();
    if (this.config.mimeTypesAccepted.includes(fileType)) {
      this.fileSelected = true;
      this.selectedFile = {
        file,
        isUploadInProgress: false,
        uploadResult: null,
      };
      if (this.config.preprocessor?.action) {
        this.config.preprocessor.action(this.selectedFile.file);
      }
    } else {
      this.fileSelector.nativeElement.value = '';
      this.cancelFile();
      this.selectionError.emit({
        message: this.translation['mime_type_unsupported'],
        errorDetail: [
          {
            code: 'userimport_config_mime_type_unsupported',
            message: this.translation['userimport_config_mime_type_unsupported'],
          },
        ],
      });
      console.error(`Unsupported MIME type: ${file.type}`);
    }
  }

  cancelFile(): void {
    this.fileSelected = false;
    this.selectedFile = {
      file: null,
      isUploadInProgress: false,
      uploadResult: null,
    };
  }
}
